import React from 'react';
import './Select.css';

function Select({
  id,
  size = 'md',
  error = false,
  disabled = false,
  placeholder,
  options = [],
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'ui-select',
    size === 'sm' ? 'ui-select--sm' : '',
    error ? 'ui-select--error' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <select
      id={id}
      className={classes}
      disabled={disabled}
      aria-invalid={error || undefined}
      {...rest}
    >
      {placeholder ? (
        <option value="" disabled>
          {placeholder}
        </option>
      ) : null}
      {children
        ? children
        : options.map((opt) => {
            const value = typeof opt === 'object' ? opt.value : opt;
            const label = typeof opt === 'object' ? opt.label : opt;
            return (
              <option key={value} value={value}>
                {label}
              </option>
            );
          })}
    </select>
  );
}

export default Select;
